/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 消费后剧院会员升级逻辑
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  theaterLevelReq: member.TheaterLevelReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: any;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/theatre-level`,
    data: theaterLevelReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
